import { Card, Table } from "@arco-design/web-react";
import { WoPickOrderAdd } from "./wo-pick-order-add";
import { WoPickOrderInfo } from "./wo-pick-order-info";
import { WoPickOrderEdit } from "./wo-pick-order-edit";
import { Link } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { formatDate } from "@/utils";
import { WOPOAPI } from "@/apis/manufacturing";
import { WOPOStatusDef, WOPOStatus } from "@/enums/manufacturing";
import { EnumSelect } from "@/components/Enum";
import { EnumLabel } from "@/components/Enum";
import { Number } from "@/components/Numeric";

const WOPO_STATUS_OPEN = "open";
const WOPO_STATUS_ALL = "all";

const statusFilterOptions = [
    { label: "All", value: WOPO_STATUS_ALL },
    { label: "Open", value: WOPO_STATUS_OPEN },
    ...Object.entries(WOPOStatusDef).map(([, v]) => ({ label: v.label, value: v.value }))
];

export const WoPickOrder = () => {
    const [data, setData] = useState([]);
    const [status, setStatus] = useState(WOPO_STATUS_OPEN);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const getList = useCallback(async () => {
        let statuses;
        if (status === WOPO_STATUS_ALL) {
            statuses = null;
        } else if (status === WOPO_STATUS_OPEN) {
            statuses = [WOPOStatus.Issued, WOPOStatus.Partial];
        } else if (status != null) {
            statuses = [status];
        }
        const values = await WOPOAPI.query(page, statuses ? { statuses } : {});
        setData(values.records);
        setTotal(values.total);
    }, [page, status]);

    useEffect(() => {
        getList();
    }, [getList]);

    return (
        <Card title="WO Pick Order" extra={
            <EnumSelect options={statusFilterOptions} placeholder="Status" style={{ width: 160 }} value={status} onChange={(val) => setStatus(val)} />
        }>
            <Table rowKey="id" columns={[
                {
                    title: "Pick Order#", dataIndex: "pickOrderNo",
                    render: (col, record) =>
                        <Link to={"/workspace/manufacturing/wo-pick-order/" + record.id}>{record.pickOrderNo}</Link>
                },
                { title: "Status", dataIndex: "status", render: (col, record) => <EnumLabel enumObj={WOPOStatusDef} value={record.status} /> },
                { title: "Created Date", dataIndex: "createTime", render: (col, record) => formatDate(record.createTime) },
                { title: "Pick Date", dataIndex: "pickDate" },
                { title: "WO Production Date", dataIndex: "productionDate" },
                { title: "BOM Name", dataIndex: "bomName", render: (col, record) => <Link to={"/workspace/manufacturing/bom/" + record.bomId}>{record.bomName}</Link> },
                { title: "Qty", dataIndex: "pickQty", render: (val) => <Number value={val} /> },
            ]} data={data} pagination={{ total, current: page, pageSize: 20 }} onChange={(pagination) => setPage(pagination.current)} />
        </Card>
    )
}

WoPickOrder.Add = WoPickOrderAdd;
WoPickOrder.Info = WoPickOrderInfo;
WoPickOrder.Edit = WoPickOrderEdit;
